import { type KeyboardEvent, type MouseEvent } from 'react'
import { useTheme } from '@dhl-ui/theme'
import { useTenant, tenantThemes, Box, type LogoProps, DHLLogo as MuiLogo } from '@dhl-ui/components'
import { type PageHeaderProps } from '../types'
import { dimensions } from './dimensions'

type Props = Pick<PageHeaderProps, 'onClick' | 'logo'> & Pick<LogoProps, 'fill'>

export const HeaderLogo = ({ onClick, fill, logo }: Props) => {
  const { variant } = useTheme()
  const { tenant } = useTenant()
  const { width, height } = dimensions(tenant)[variant]

  // Prefer explicit logo prop → tenant registry logo → DHL default
  const TenantLogo = logo ?? tenantThemes[tenant]?.logo ?? MuiLogo

  // space and enter key while on focus will go to click handler as well
  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick?.action?.()
    }
  }

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    if (onClick?.action) {
      event.preventDefault()
      onClick.action()
    }
  }

  return (
    <Box
      onClick={handleClick}
      onKeyDown={onClick ? handleKeyDown : undefined}
      sx={{ width, height, lineHeight: 0, outline: 0 }}
      aria-label={onClick?.label ?? ''}
      aria-hidden={onClick ? undefined : true}
      href={onClick?.href}
      // FIXME: smell a div can not have href
      component={onClick ? 'a' : 'div'}
    >
      <TenantLogo width={width} height={height} fill={fill} />
    </Box>
  )
}
